import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app-config.loader';
import { IdentityService } from '../../auth/identity.service';
import { LoginError } from '../identity.model';

@Component({
  selector: 'app-login',
  template: `
  <div class="fullscreen">
    <div class="centered">
      <img [src]="mainImage" alt="" class="logo" /><br/>
      <span *ngIf="working">Accesso al sistema in corso...</span>
      <span *ngIf="completedWithError" style="color: red;">Errore durante l'accesso al sistema</span>
      <span *ngIf="unauthorized" style="color: red;">Utente non abilitato</span>
      <p *ngIf="!working">
        <label for="username">Utente</label>
        <input #usernameEl type="text" id="username" [(ngModel)]="username" autocomplete="off" (keyup)="userKeyUp($event)" />
        <label for="password">Password</label>
        <input #passwordEl type="password" id="password" [(ngModel)]="password" (keyup)="passwordKeyUp($event)" />
        <button type="button" (click)="performLogin()" [disabled]="working"><i class="fas fa-fw fa-sign-in-alt"></i>Login</button>
      </p>
    </div>
  </div>
  `,
  styles: [`
    label { font-size: 40px; vertical-align: sub; margin-left: 50px; margin-right: 20px; color: darkslategrey; }
    input { font-family: "Keytin", "Segoe UI", Roboto; font-size: 30px; letter-spacing: 3px; width: 200px; }
    button { font-family: "Keytin", "Segoe UI", Roboto; font-size: 30px; letter-spacing: 3px; margin-left: 50px;
      background-color: white; border: 1px solid grey; }
    .fullscreen { position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; background-color: rgb(255, 255, 255); z-index: 1; }
    .logo { border: 0px; width: 100vw; max-width: 1400px; }
    .container { position: relative; }
    .centered { margin-left: auto; margin-right: auto; max-width: 1400px; text-align: center;
      font-family: "Keytin", "Segoe UI", Roboto; letter-spacing: 2px;
    }
    .centered span { font-size: 30px; font-weight: bold; }
  `]
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('usernameEl') usernameElement!: ElementRef<HTMLInputElement>;
  @ViewChild('passwordEl') passwordElement!: ElementRef<HTMLInputElement>;

  public returnUrl: string;
  public working: boolean;
  public completedWithError: boolean;
  public unauthorized: boolean;
  public username: string;
  public password: string;
  public mainImage = "";

  constructor(private appConfig: AppConfig, private router: Router, private route: ActivatedRoute, private identity: IdentityService) { }

  ngOnInit(): void {
    this.mainImage = this.appConfig.logic.logo.login;
    this.working = false;
    this.completedWithError = false;
    this.returnUrl = this.route.snapshot.queryParams.returnUrl as string;

    if (this.appConfig.settings.jwt.useSSO) {
      this.performSSOLogin();
    }

    // autologin
    // if (!environment.production) {
    //   this.username = 'test';
    //   this.password = 'test';
    //   this.performLogin();
    // }
  }

  ngAfterViewInit(): void {
    this.usernameElement?.nativeElement.focus();
  }

  performSSOLogin(): void {
    this.working = true;
    this.completedWithError = false;
    this.unauthorized = false;
    this.identity.login().subscribe(() => this.loginCompleted(), (error: LoginError) => this.loginError(error));
  }

  performLogin(): void {
    this.working = true;
    this.completedWithError = false;
    this.unauthorized = false;
    this.identity.loginWithUsername(this.username, this.password).subscribe(() => this.loginCompleted(), (error: LoginError) => this.loginError(error));
  }

  userKeyUp(e: KeyboardEvent): void {
    if (e.code === 'Enter') {
      this.passwordElement.nativeElement.focus();
    }
  }

  passwordKeyUp(e: KeyboardEvent): void {
    if (e.code === 'Enter') {
      this.performLogin();
    }
  }

  private loginCompleted() {
    if (this.identity.isLogged$.getValue()) {
      const urlSplit = this.returnUrl.split('?');
      const queryParams = {};
      if (urlSplit.length > 1) {
        for (const params of urlSplit[1].split('&')) {
          const values = params.split('=');
          queryParams[values[0]] = values[1];
        }
      }

      void this.router.navigate([urlSplit[0]], { queryParams });
    } else {
      this.working = false;
      this.completedWithError = false;
      this.unauthorized = true;
    }
  }

  private loginError(error: LoginError) {
    this.working = false;
    this.completedWithError = true;
    this.unauthorized = false;
    if (error.message) {
      console.error('Errore elaborazione token JWT: ' + error.statusText);
    } else {
      console.error('Errore invocazione API login: ' + error.statusText);
    }
  }
}
